import { GET_ALL_AGENDA, GET_AGENDA } from "../actions/actionTypes";

const initialState = {
  agenda: [],
  selectedAgenda: null,
};

export default function agenda(state = initialState, action) {
  switch (action.type) {
    case GET_ALL_AGENDA:
      return {
        ...state,
        agenda: action.payload || [],
      };
    case GET_AGENDA:
      return {
        ...state,
        selectedAgenda: action.payload,
      };
    default:
      return state;
  }
}
